export const omit = (o, ...keys) => keys.reduce((memo, key) => {
	const {[key]: ignored, ...rest} = memo;
	return rest;
}, o);
export const isDefined = x => x !== undefined;
export const valueFilter = filter => object => Object.keys(object).reduce((passed, key) => !filter(object[key]) ? passed : {
	...passed,
	[key]: object[key]
}, {});
export const mergeDefined = (...objects) => Object.assign({}, ...objects.map(valueFilter(isDefined)));

// This function can be rewritten after new sync has been implemented.
// For older sync article object has key "_attr1_id"
// For newer sync article object has key "attr1_id"
// For social shares article object has key "attribute1Id"
export const sanitizeAttr1IdKeyValue = article => {
	const keys = Object.keys(article);

	if (keys.includes('attribute1Id')) {
		return article.attribute1Id !== -1 ? article.attribute1Id : undefined;
	}

	if (keys.includes('attr1_id')) {
		return article.attr1_id !== -1 ? article.attr1_id : undefined;
	}

	return article._attr1_id !== -1 ? article._attr1_id : undefined;
};
